// extracted by mini-css-extract-plugin
module.exports = {"tab":"usersView_tab__3Na6B"};